import { createFileRoute, redirect } from "@tanstack/react-router";

/** Soporte vive en Panel → Estado de plataforma (paridad Booking Hub). */
export const Route = createFileRoute("/admin/ops/support")({
  beforeLoad: () => {
    throw redirect({ to: "/admin", search: { tab: "support-inbox" } as never });
  },
});
